// Minimal markdown renderer for policy content (headings, bold, bullets, blockquote).
function inline(text) {
    const parts = text.split(/(\*\*[^*]+\*\*)/g);
    return parts.map((p, i) =>
        p.startsWith("**") && p.endsWith("**")
            ? <strong key={i} className="font-bold text-navy">{p.slice(2, -2)}</strong>
            : <span key={i}>{p}</span>
    );
}

export function Markdown({ content = "" }) {
    const lines = content.split("\n");
    const out = [];
    let list = [];
    const flush = () => {
        if (list.length) {
            out.push(<ul key={`ul-${out.length}`} className="my-2 list-disc space-y-1 pl-5 text-sm text-navy/70">{list}</ul>);
            list = [];
        }
    };
    lines.forEach((raw, idx) => {
        const line = raw.trimEnd();
        if (!line.trim()) { flush(); return; }
        if (line.startsWith("### ")) { flush(); out.push(<h3 key={idx} className="mt-4 font-heading text-base font-bold text-navy">{inline(line.slice(4))}</h3>); return; }
        if (line.startsWith("## ")) { flush(); out.push(<h2 key={idx} className="mt-5 font-heading text-lg font-extrabold text-navy">{inline(line.slice(3))}</h2>); return; }
        if (line.startsWith("# ")) { flush(); out.push(<h1 key={idx} className="mt-5 font-heading text-xl font-extrabold text-navy">{inline(line.slice(2))}</h1>); return; }
        if (line.startsWith("> ")) { flush(); out.push(<blockquote key={idx} className="my-3 rounded-r-xl border-l-4 border-orange bg-orange/5 px-4 py-2 text-sm text-navy/70">{inline(line.slice(2))}</blockquote>); return; }
        if (/^[-*]\s+/.test(line)) { list.push(<li key={idx}>{inline(line.replace(/^[-*]\s+/, ""))}</li>); return; }
        flush();
        out.push(<p key={idx} className="my-2 text-sm leading-relaxed text-navy/70">{inline(line)}</p>);
    });
    flush();
    return <div className="legal-body">{out}</div>;
}
